import { useState, useEffect } from "react";
import { C, S } from '../constants';
import { toLocalDate } from '../utils';

export { toLocalDate };

export default function DatePicker({ from, to, onApply }) {
  const [f, setF] = useState(from || "");
  const [t, setT] = useState(to || "");
  const [activePreset, setActivePreset] = useState("7 днів");

  useEffect(() => { if (from) setF(from); if (to) setT(to); }, [from, to]);

  const preset = (days, label, isYesterday) => {
    setActivePreset(label);
    if (days === null) { setF(""); setT(""); onApply(null, null, true); return; }
    const now = new Date();
    if (isYesterday) {
      const yest = new Date(now);
      yest.setDate(yest.getDate() - 1);
      yest.setHours(0, 0, 0, 0);
      const fv = toLocalDate(yest);
      setF(fv); setT(fv);
      onApply(fv, fv, true);
      return;
    }
    const s = new Date(now);
    if (days === 0) s.setHours(0, 0, 0, 0);
    else s.setDate(s.getDate() - days);
    const fv = toLocalDate(s);
    const tv = toLocalDate(now);
    setF(fv); setT(tv);
    onApply(fv, tv, true);
  };

  const presets = [["7 днів", 7], ["30 днів", 30], ["90 днів", 90], ["Рік", 365], ["Все", null]];

  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <div style={{
        display: "flex", gap: 3, background: C.bg0, padding: 4,
        borderRadius: 12, border: `1px solid ${C.border}`,
      }}>
        {presets.map(([l, d]) => {
          const isActive = activePreset === l;
          return (
            <div key={l} onClick={() => preset(d, l, d === "yesterday")} style={{
              padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600,
              cursor: "pointer", userSelect: "none", transition: "all .15s",
              background: isActive ? `${C.blue}22` : "transparent",
              color: isActive ? C.blue : C.text3,
              border: `1px solid ${isActive ? C.blue + "40" : "transparent"}`,
            }}
            onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = C.bg3; e.currentTarget.style.color = C.text2; } }}
            onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.text3; } }}
            >{l}</div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <input type="date" value={f} onChange={e => { setF(e.target.value); setActivePreset(null); }}
          style={{ ...S.input, padding: "6px 10px", colorScheme: "dark", fontSize: 12 }} />
        <span style={{ color: C.text4, fontSize: 14 }}>—</span>
        <input type="date" value={t} onChange={e => { setT(e.target.value); setActivePreset(null); }}
          style={{ ...S.input, padding: "6px 10px", colorScheme: "dark", fontSize: 12 }} />
        <button onClick={() => f && t && onApply(f, t, false)} style={{
          padding: "7px 20px", borderRadius: 9,
          background: `linear-gradient(135deg, ${C.blue}, #3b82f6)`,
          color: "#fff", border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700,
          boxShadow: `0 2px 12px ${C.blue}40`,
          letterSpacing: "0.2px",
        }}>Застосувати</button>
      </div>
    </div>
  );
}
